import { StringParam, useQueryParam } from "use-query-params";

export const useSearch = () => {
  const [search, setSearch] = useQueryParam("search", StringParam);

  return [search ?? undefined, setSearch] as const;
};
